import { useContext } from "react";
import { useFormikContext } from "formik";
import get from "lodash-es/get";
import { AppThemeGradientContext } from "contexts/appCustomization/AppThemeGradientContext";

export default function usePreview() {
  const { values } = useFormikContext();
  const { values: orders } = useContext(AppThemeGradientContext);

  const mode = get(values, "mode");
  const gradient = get(values, [mode, "gradient"]);
  const primary = get(values, [mode, "primary"]);
  const svgLogo = get(values, "svgLogo");
  const pngLogo = get(values, [mode, "pngLogo"]);

  const order = get(orders, mode, []);
  const gradientInOrder = order.map((item) => gradient[item]);

  return {
    mode,
    gradient: gradientInOrder,
    primary,
    logo: svgLogo || pngLogo,
  };
}
